
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Added new components to our `}<a parentName="p" {...{
        "href": "https://pxblue-components.github.io/angular"
      }}>{`Angular`}</a>{` and `}<a parentName="p" {...{
        "href": "https://pxblue-components.github.io/react-native"
      }}>{`React Native`}</a>{` component libraries, added the `}<a parentName="p" {...{
        "href": "https://codesandbox.io/s/github/pxblue/react-design-patterns"
      }}>{`React Design Pattern mono repo`}</a>{`, introduced the `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/package/@pxblue/cli"
      }}>{`PX Blue CLI`}</a>{`, added search functionality to our documentation site, introduced reusable `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/package/@pxblue/react-native-auth-workflow"
      }}>{`Authentication Workflow`}</a>{` for React Native, and published our `}<a parentName="p" {...{
        "href": "https://www.figma.com/community/file/852558784352181868"
      }}>{`sticker sheet`}</a>{` to the Figma community.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;